import React from "react";
import PropTypes from "prop-types";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";

export default class RowActionMenuPopover extends React.Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    formDataFiltered: PropTypes.arrayOf(PropTypes.object).isRequired,
    rowIndex: PropTypes.number.isRequired,
    onStatusRowClick: PropTypes.func.isRequired,
    onChangeOrderOpen: PropTypes.func.isRequired,
    onDeleteFormButtonClick: PropTypes.func.isRequired,
    onGetSourceFileClick: PropTypes.func.isRequired,
    onFormJSONClick: PropTypes.func.isRequired,
    onRecallButtonClick: PropTypes.func.isRequired,
    onMakeTemplateButtonClick: PropTypes.func.isRequired,
    actions: PropTypes.shape({ openDetailsModal: PropTypes.func.isRequired })
      .isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  handleTouchTap = event => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false
    });
  };

  render() {
    return (
      <div>
        <IconButton
          onClick={this.handleTouchTap}
          style={{ marginLeft: "-6px" }}
        >
          <MenuIcon />
        </IconButton>

        <Menu
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          onClose={this.handleRequestClose}
        >
          <MenuItem
            onClick={e => {
              this.props.onStatusRowClick(e, this.props.rowIndex);
              this.props.actions.openDetailsModal();
              this.handleRequestClose();
            }}
          >
            Show Errors/Warnings
          </MenuItem>
          <MenuItem
            onClick={e => {
              this.props.onStatusRowClick(e, this.props.rowIndex);
              this.props.onFormJSONClick();
              this.handleRequestClose();
            }}
          >
            View form data
          </MenuItem>
          <MenuItem
            disabled={
              this.props.formDataFiltered[this.props.rowIndex]
                .submission_source !== "DM_API"
            }
            onClick={e => {
              this.props.onStatusRowClick(e, this.props.rowIndex);
              this.props.onRecallButtonClick();
              this.handleRequestClose();
            }}
          >
            Recall Form
          </MenuItem>

          <MenuItem
            disabled={
              this.props.formDataFiltered[this.props.rowIndex]
                .submission_source !== "DM_API"
            }
            onClick={e => {
              this.props.onStatusRowClick(e, this.props.rowIndex);
              this.props.onMakeTemplateButtonClick();
              this.handleRequestClose();
            }}
          >
            Send as Template (Beta)
          </MenuItem>

          <MenuItem
            primarytext="Change Form order"
            onClick={e => {
              this.props.onStatusRowClick(e, this.props.rowIndex);
              this.props.onChangeOrderOpen();
              this.handleRequestClose();
            }}
          >
            Change Form order
          </MenuItem>
          <MenuItem
            onClick={e => {
              this.props.onStatusRowClick(e, this.props.rowIndex);
              this.props.onDeleteFormButtonClick();
              this.handleRequestClose();
            }}
          >
            Delete/Undelete submission
          </MenuItem>
          <MenuItem
            disabled={
              this.props.formDataFiltered[this.props.rowIndex]
                .has_source_file === false
            }
            onClick={e => {
              this.props.onStatusRowClick(e, this.props.rowIndex);
              this.props.onGetSourceFileClick();
              this.handleRequestClose();
            }}
          >
            Get submitted file
          </MenuItem>
        </Menu>
      </div>
    );
  }
}
